import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type TagSeverity = 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'contrast';

@Component({
  selector: 'app-tag',
  template: `
    <span [class]="classes()" [attr.role]="'status'">
      @if (icon()) {
        <i [class]="icon() + ' mr-1'" aria-hidden="true"></i>
      }
      {{ value() }}
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UiTag {
  readonly value = input<string>('');
  readonly severity = input<TagSeverity>('primary');
  readonly icon = input<string>('');

  protected classes(): string {
    const base = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
    const variants: Record<TagSeverity, string> = {
      primary: 'bg-accent-100 text-accent-700',
      secondary: 'bg-slate-100 text-slate-600',
      success: 'bg-teal-100 text-teal-700',
      info: 'bg-sky-100 text-sky-700',
      warning: 'bg-amber-100 text-amber-700',
      danger: 'bg-rose-100 text-rose-700',
      contrast: 'bg-slate-800 text-white',
    };
    return `${base} ${variants[this.severity()]}`;
  }
}
